import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from 'src/app/core/course.service';
import { DeviceService } from 'src/app/core/device.service';
import { ExamService } from 'src/app/core/exam.service';
import { HeaderService } from 'src/app/core/header.service';
import { PremiumFeatureDialogService } from 'src/app/core/premium-feature-dialog.service';
import { UserService } from 'src/app/core/user.service';
import { Course } from 'src/app/models/course.model';
import { Exam } from 'src/app/models/exam.model';
import { Learnset } from 'src/app/models/learnset.model';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-course-view',
  templateUrl: './course-view.component.html',
  styleUrls: ['./course-view.component.scss'],
  standalone: false,
})
export class CourseViewComponent {
  
  deviceSize?: 'mobile' | 'tablet' | 'desktop';
  user?: User;

  breadcrumbs: any;
  course?: Course;
  createLearnset: boolean = false;
  
  showActions: boolean = false;
  actionsList: any = [
    {
      icon: 'pencil',
      text: 'Kurs bearbeiten',
      action: 'edit',
      style: 'neutral'
    },
    {
      icon: 'trash',
      text: 'Kurs löschen',
      action: 'delete',
      style: 'error'
    }
  ];

  tabButtons: any = [
    {
      text: 'Lernsets',
      icon: 'cards',
      view: 'learnsets'
    },
    {
      text: 'Probeklausuren',
      icon: 'file-text-spark',
      view: 'quizzes'
    },
  ];
  currentTab = 'learnsets';
  selectedTabButton: any = this.tabButtons[0];

  showEditCourse: boolean = false;
  showCreateExam: boolean = false;

  exams: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private courseService: CourseService,
    private headerService: HeaderService,
    private examService: ExamService,
    private userService: UserService,
    private deviceService: DeviceService,
    private premiumFeatureService: PremiumFeatureDialogService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(paramMap => {
      const courseId = paramMap.get('id');
      this.course = undefined;
      if (courseId) {
        this.fetchCourse(courseId);
        this.getExams();
      }
    });

    this.deviceSize = this.deviceService.getDeviceSize();

    this.headerService.getActionsClickObservable().subscribe(() => {
      this.handleActionsClick();
    });

    this.userService.getUser().subscribe((user: User) => {
      this.user = user;
    });
  }

  changeView(event: any) {
    this.currentTab = event.view;

    if (this.currentTab === 'quizzes') {
      this.getExams();
    }
  }

  fetchCourse(courseId: string): void {
    this.courseService.getCourse(courseId)
      .subscribe((course: any) => {
        this.course = Course.constructCourse(course);
        this.breadcrumbs = [
          {
            text: 'Kurse',
            route: 'courses'
          },
          {
            text: this.course!.name,
            route: `courses/${this.course!.id}`
          }
        ];
      });
  }

  addLearnset() {
    this.createLearnset = true;
  }

  showLearnset(learnset: Learnset) {
    this.router.navigate([`sets/${learnset.id}`]);
  }

  editCourse() {
    this.router.navigate([`courses/${this.course?.id}/edit`]);
  }

  handleActionsClick() {
    this.showActions = true;
  }

  handleAction(action: string) {
    if (action === 'edit') {
      this.showEditCourse = true;
    } else if (action === 'delete') {
      this.deleteCourse();
    }
    this.showActions = false;
  }

  createTest() {
    if (this.user?.isPremiumUser) {
      this.showCreateExam = true;
    } else {
      this.premiumFeatureService.showDialog('Teste dein Wissen mit KI-Probeklausuren', 'So funktioniert es: Wähle Lernsets aus deinem Kurs aus und die Sparkly-KI erstellt automatisch eine Probeklausur für dich, die du direkt absolvieren kannst. Die KI gibt dir im Anschluss eine Note und individuelles Feedback zu deinen Antworten.');
    }
    /*this.examService.createExam(this.course?.id!).subscribe((result) => {
      const examId = result.id;
      this.router.navigate([`courses/${this.course?.id}/exam/${examId}`]);
    });*/
  }

  getExams() {
    this.examService.getExams(this.course?.id!).subscribe((result) => {
      this.exams = result.map((result: any) => Exam.constructExam(result));
    });
  }

  deleteCourse() {
    this.courseService.deleteCourse(this.course!.id!).subscribe(result => {
      this.router.navigate(['courses']);
    });
  }

  learnsetCreated() {
    this.createLearnset = false;
    this.fetchCourse(this.course!.id!.toString());
  }

  handleExamClick(exam: Exam) {
    this.router.navigate([`courses/${this.course!.id}/exam/${exam.id}`]);
  }
}
